/**
 * @file: number report
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import cn from 'classnames';
import {InputItem, TextareaItem} from 'antd-mobile';
import exif from 'exif-js';

import './index.less';

import {getValidate} from './utils';

/* istanbul ignore file */
export class Upload extends PureComponent {
    static propTypes = {
        onChange: PropType.func,
        validate: PropType.func,
        fileSize: PropType.number,
        fileType: PropType.string,
        value: PropType.string,
        isRequire: PropType.bool,
        labelName: PropType.string,
        className: PropType.string,
        name: PropType.string
    }
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    readFile(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.addEventListener('load', resolve);
            fileReader.addEventListener('error', reject);
            fileReader.readAsDataURL(file);
        });
    }

    compressImage(base64Data, orientation, quality, scale = 1) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.addEventListener('load', () => {
                const width = image.width * scale;
                const height = image.height * scale;
                const cvs = document.createElement('canvas');

                const context = cvs.getContext('2d');
                cvs.height = height;
                cvs.width = width;
                if (orientation && orientation !== 1) {
                    switch (orientation) {
                        case 6: // 旋转90度
                            cvs.height = width;
                            cvs.width = height;
                            context.rotate(Math.PI / 2);
                            context.drawImage(image, 0, -height, width, height);
                            break;
                        case 3: // 旋转180度
                            context.rotate(Math.PI);
                            context.drawImage(image, -width, -height, width, height);
                            break;
                        case 8: // 旋转-90度
                            cvs.height = width;
                            cvs.width = height;
                            context.rotate(3 * Math.PI / 2);
                            context.drawImage(image, -width, 0, width, height);
                            break;
                    }
                }
                else {
                    context.drawImage(image, 0, 0, width, height);
                }
                const dataURL = cvs.toDataURL('image/jpeg', quality);

                resolve(dataURL);
            });

            image.addEventListener('error', reject);
            image.src = base64Data;
        });
    }

    dataURLtoFile(base64Data, filename) {
        const arr = base64Data.split(',');
        // const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = window.atob(arr[1]);
        let len = bstr.length;
        const u8arr = new window.Uint8Array(len);
        while (len--) {
            u8arr[len] = bstr.charCodeAt(len);
        }
        return new File([u8arr], filename, {type: 'image/jpg'});
    }

    getOriention(file) {
        return new Promise(resolve => {
            exif.getData(file, function () {
                resolve(exif.getTag(this, 'Orientation'));
            });
        });
    }

    async onChange(e) {
        const {fileSize, fileType, validate, onChange} = this.props;
        const file = e.target.files[0];
        const reg = /\.(jpg|png|jpeg)$/;

        // 优先判断是不是jpg|png|jpeg其中一种如果是则判断大小是否超过1m如果超过则压缩转换
        // 如果小于1m判断是否是jpg|png
        if (!reg.test(file.name)) {
            return validate({validate: true, message: '图片格式不正确'});
        }

        if (fileType && (`${fileType};image/jpeg`).indexOf(file.type) < 0) {
            return validate({validate: true, message: '图片格式不正确'});
        }

        if (fileSize && file.size > fileSize) {
            const scale = (1024 * 1024) / file.size;
            const orientation = await this.getOriention(file);
            const data = await this.readFile(file);
            const fdate = await this.compressImage(data.target.result, orientation, scale, scale);

            const compressFile = this.dataURLtoFile(fdate, file.name);

            if (fileSize && compressFile.size > fileSize) {
                return validate({validate: true, message: '图片大小不符合要求'});
            }

            if (fileType && fileType.indexOf(compressFile.type) < 0) {
                return validate({validate: true, message: '图片格式不正确'});
            }

            onChange && onChange(fdate, compressFile);

            return;
        }

        if (fileType
            && (fileType).indexOf(file.type) < 0
            && !/\.(jpg|png)$/.test(file.name)) {
            return validate({validate: true, message: '图片格式不正确'});
        }

        validate({validate: false, message: ''});
        const data = await this.readFile(file);

        onChange && onChange(data.target.result, file);
    }
    render() {
        const {value, onChange, isRequire, validate, labelName, name, className} = this.props;
        return (
            <div>
                {
                    value
                        ? (
                            <div className="upload-image">
                                <img src={value} alt="" />
                                <div className="upload-image-mask">
                                    <img
                                        onClick={() => {
                                            if (isRequire) {
                                                validate({validate: true, message: `${labelName}不能为空!`});
                                            }
                                            onChange && onChange('', null);
                                        }}
                                        src={require('../../asset/svg/icon_trash_normal.svg')} alt="" />
                                </div>
                            </div>
                        )
                        : (
                            <label className={cn('upload', className)}>
                                <img src={require('../../asset/svg/icon_upload.svg')} alt="" />
                                <span>上传图片</span>
                                <input
                                    style={{display: 'none'}}
                                    type="file"
                                    name={name || labelName}
                                    accept="image/*"
                                    multiple={false}
                                    onChange={this.onChange} />
                            </label>
                        )
                }
            </div>
        );
    }
}

export class Select extends PureComponent {
    static propTypes = {
        data: PropType.array,
        onChange: PropType.func
    }

    state = {
        value: undefined
    }

    render() {
        const {data, onChange, ...props} = this.props;
        return (
            <div className="form-select">
                <select {...props} onChange={e => onChange && onChange(e.target.value)}>
                    {data && data.map(item => {
                        return <option key={item.value} value={item.value}>{item.label}</option>;
                    })}
                </select>
                <div className="arrow"></div>
            </div>
        );
    }
}

export class CodePic extends PureComponent {
    static propTypes = {
        resetCaptcha: PropType.func
    }
    state = {
        tmp: Date.now()
    }

    resetCode = () => {
        this.setState({tmp: Date.now()});

        this.props.resetCaptcha && this.props.resetCaptcha();
    }

    render() {
        return (
            <div
                className="component-code"
                onClick={this.resetCode}>
                <img src={`/xiapi/api/v1/phone/captcha?t=${this.state.tmp}`} alt="" />
                <span className="">刷新验证码</span>
            </div>
        );
    }
}

export class FormItem extends PureComponent {
    static propTypes = {
        isRequire: PropType.bool,
        label: PropType.string || PropType.node,
        des: PropType.string || PropType.node,
        placeholder: PropType.string,
        type: PropType.string,
        className: PropType.string,
        comClassName: PropType.string,
        rules: PropType.array,
        value: PropType.any,
        renderRight: PropType.func,
        noLabel: PropType.bool
    };

    constructor(props) {
        super(props);

        this.Item = {
            input: InputItem,
            textarea: TextareaItem,
            select: Select,
            upload: Upload
        };

        this.state = {
            validate: '',
            message: ''
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value && this.state.validate) {
            const validate = getValidate(this.props.rules, this.props.value || '').message;

            if (!validate) {
                this.setState({validate: false, message: ''});
            }
        }
    }

    validate = cusValidate => {
        if (cusValidate) {
            this.setState({validate: cusValidate.validate, message: cusValidate.message});
            return;
        }

        const {validate, message} = getValidate(this.props.rules, this.props.value || '');
        this.setState({validate, message});

        return {validate, message};
    }

    render() {
        const {
            isRequire,
            label,
            des,
            placeholder,
            type,
            className,
            comClassName,
            noLabel,
            renderRight,
            ...props} = this.props;
        const Com = this.Item[type];
        const extraProps = type === 'upload' ? {
            validate: this.validate,
            isRequire
        } : {};

        return (
            <div className={cn('form-item', className)}>
                {!noLabel && <div className="form-label">
                    <label>
                        {isRequire && <span className="hint-star">*</span>}
                        {label}
                    </label>
                    {des
                        && <div className="des">
                            {des}
                        </div>}
                </div>}
                <div className={cn({horizontal: !!renderRight})}>
                    {Com && <Com
                        placeholder={placeholder}
                        {...props}
                        rules={undefined}
                        {...extraProps}
                        className={cn(comClassName, {error: this.state.validate})} />}
                    {renderRight && renderRight()}
                </div>
                {this.state.validate
                    && <div className="error-message">{this.state.message}</div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/numberOptions/formCom.js